import { graphql } from "gql";

const ADMIN_CREATE_USER_MUTATION = graphql(`
  mutation AdminCreateUser($input: AdminCreateUserInput!) {
    adminCreateUser(input: $input) {
      ...User
    }
  }
`);

export default ADMIN_CREATE_USER_MUTATION;
